import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { useCarrierOrders } from '../../hooks/useCarrierOrders';
import { ORDER_TABS, STATUS_LABEL, STATUS_TONE, ordersForTab, countByTab } from '../../utils/carrierOrderStatus';
import { orderTitle } from '../../utils/orderTitle';
import { placeName, toDate, dayLabel, timeLabel } from '../../utils/orderCardFormat';
import { ui, chip } from './carrierStyles';

function whenText(order) {
  const d = toDate(order.scheduledAt);
  return d ? `${dayLabel(d)} ${timeLabel(d)}` : '';
}

export default function CarrierOrders() {
  const { orgId, isStaff, loading: orgLoading } = useCarrierOrg();
  const { orders, loading, error } = useCarrierOrders(orgId);
  const [tab, setTab] = useState('planned');

  if (orgLoading) return <p style={ui.hint}>Laster…</p>;
  if (!isStaff) return <p style={ui.hint}>Bare administratorer og dispatchere ser ordrene.</p>;

  const counts = countByTab(orders);
  const shown = ordersForTab(orders, tab);

  return (
    <>
      <div style={{ ...ui.row, justifyContent: 'space-between' }}>
        <h1 style={ui.h1}>Ordre</h1>
        <Link to="/transportor/ordre/ny" className="tippi-btn" style={{ ...ui.btn, display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>Ny ordre</Link>
      </div>

      <div role="tablist" style={{ ...ui.row, marginBottom: 12 }}>
        {ORDER_TABS.map(t => (
          <button key={t.key} type="button" role="tab" aria-selected={tab === t.key} onClick={() => setTab(t.key)}
                  style={{ ...ui.btnSecondary, ...(tab === t.key ? { background: 'var(--color-primary)', color: 'var(--color-on-primary)' } : {}) }}>
            {t.label}{counts[t.key] > 0 ? ` ${counts[t.key]}` : ''}
          </button>
        ))}
      </div>

      {error && <p role="alert" style={ui.error}>Kunne ikke hente ordrene. Last siden på nytt.</p>}
      <div style={ui.card}>
        {loading && <p style={ui.hint}>Laster…</p>}
        {!loading && shown.length === 0 && <p style={ui.hint}>Ingen ordre her.</p>}
        {shown.map(o => (
          <Link key={o.id} to={`/transportor/ordre/${o.id}`} style={{ ...ui.link, ...ui.listRow }}>
            <span>
              <strong>{orderTitle(o)}</strong>
              <span style={{ display: 'block', ...ui.hint }}>{o.customer?.name ?? 'Ukjent kunde'}</span>
              <span style={{ display: 'block', ...ui.hint }}>{placeName(o.pickupAddress)} → {placeName(o.deliveryAddress)} · {whenText(o)}</span>
            </span>
            <span style={chip(STATUS_TONE[o.status] ?? 'none')}>{STATUS_LABEL[o.status] ?? o.status}</span>
          </Link>
        ))}
      </div>
    </>
  );
}
